import React from 'react';

import { Col, Row } from 'react-bootstrap';

import {
    ControlPageBlock,
    InputField,
    SearchSelectorField,
    TextAreaField,
} from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import { API_DOMAIN, PROJECT_PREFIX } from '../const';

export default class BetakeyEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            not_valid: {},
            data: {
                game: '',
                name: '',
                text: '',
                template_for_email: '',
                number_of_keys: 0,
                code: '',
            },
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleData = this.handleData.bind(this);
        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);
        this.goToNewPage = this.goToNewPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);

        if (props.match.params.keyId) {
            this.state.API_ENDPOINT = `betakeys/${props.match.params.keyId}/keys/`;
        } else {
            this.setState({});
            this.state.API_ENDPOINT = 'betakeys/';
        }
    }

    handleData(data) {
        this.setState({ loading: false, data });
    }

    sendData(event) {
        this.validate();
        const save_type = event.currentTarget.id;
        let request_method = 'PUT';

        if (!this.props.match.params.keyId) {
            request_method = 'POST';
        }

        let callback = this.handleData;

        if (save_type === 'save_button') {
            callback = this.goToPreviousPage;
        }

        if (!this.props.match.params.keyId) {
            callback = this.goToNewPage;
        }

        Fetcher(this.state.API_ENDPOINT, request_method, callback, this.state.data);
    }

    goToNewPage(newData) {
        this.setState({ API_ENDPOINT: `betakeys/${newData.id}/keys/` });
        this.props.history.push(`${PROJECT_PREFIX}/betakeys/${newData.id}/edit`);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/betakeys/all`);
    }

    removeData() {
        Fetcher(this.state.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    handleChange(event) {
        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        this.setState(new_state);
    }

    componentDidMount() {
        if (this.props.match.params.keyId) {
            Fetcher(this.state.API_ENDPOINT, 'GET', this.handleData);
        } else {
            this.setState({
                loading: false,
                data: {
                    game: '',
                    name: '',
                    text: '',
                    template_for_email: '',
                    number_of_keys: 0,
                    code: '',
                },
            });
        }
    }

    validate() {
        const no_valid_fields = {};
        const req_fields = ['game', 'name', 'template_for_email'];

        for (let i = 0; i < Object.keys(req_fields).length; i++) {
            if (!this.state.data[req_fields[i]]) {
                no_valid_fields[req_fields[i]] = true;
            }
        }

        this.setState({ not_valid: Object.assign(this.state.not_valid, no_valid_fields) });
    }

    render() {
        if (this.state.loading) {
            return null;
        }

        return (
            <div>
                <div className="container">
                    <Row className="show-grid">
                        <Col md={12}>
                            <h3>
                                Бета-ключ:
                                {this.state.data.name}
                            </h3>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={8}>
                            <InputField
                                name="name"
                                label="Название"
                                value={this.state.data.name}
                                onChange={this.handleChange}
                                required
                                is_not_valid={this.state.not_valid.name || false}
                            />
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={8}>
                            <SearchSelectorField
                                name="game"
                                label="Игра"
                                value={[this.state.data.game]}
                                onChange={this.handleChange}
                                uri={`${API_DOMAIN}games/`}
                                isMulti={false}
                                required
                                is_not_valid={this.state.not_valid.game || false}
                            />
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={8}>
                            <TextAreaField
                                name="text"
                                label="Список ключей"
                                value={this.state.data.text}
                                onChange={this.handleChange}

                            />
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={8}>
                            <TextAreaField
                                name="template_for_email"
                                label="Шаблон для письма"
                                value={this.state.data.template_for_email}
                                onChange={this.handleChange}
                                required
                                is_not_valid={this.state.not_valid.template_for_email || false}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="container-fluid">
                    <ControlPageBlock
                        name={this.state.data.name}
                        onSave={this.sendData}
                        onApply={this.sendData}
                        onRemove={this.removeData}
                        onCancel={this.goToPreviousPage}
                    />
                </div>
            </div>
        );
    }
}
